<app-navbar></app-navbar>

<div class="instructor-section">
  <div class="instructor-wrapper" *ngFor="let member of teamMembers">

    <!-- LEFT IMAGE -->
    <div class="instructor-image">
      <img [src]="member.imageUrl" [alt]="member.name" />
    </div>

    <!-- RIGHT CONTENT -->
    <div class="instructor-content">
      <h2 class="name">{{ member.name }}</h2>
      <h3 class="title"><i>{{ member.title }}</i></h3>

      <div class="bio">
        <p>{{ member.description }}</p>
      </div>
    </div>

  </div>
</div>

<app-footer></app-footer>
